
import {email, required, minLength} from "vuelidate/lib/validators";

import FormButton from "@/components/main/buttons/FormButton";
import isMob768 from "@/mixins/isMob";
import FormInput from "./FormInput";
import CheckBoxRed from "@/components/main/core/CheckBoxRed"
import CheckBoxRememberMe from "@/components/main/core/CheckBoxRememberMe"
import "@/plugins/vuelidate"

export default {
  name: "SingInForm",
  mixins: [isMob768],
  components: { FormButton, FormInput, CheckBoxRed, CheckBoxRememberMe },
  data() {
    return {
      isError: false,
      email: '',
      password: '',
      rememberMe: false,
      test: false,

      deferredPrompt: null,
      isShowInstallButton: false,
    }
  },
  validations: {
    password: {required, minLength: minLength(6)},
    email: {
      required,
      email: value => {
        if (/\s/.test(value)) {
          return false;
        }
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return emailRegex.test(value);
      }
    },
  },
  computed: {

    allOk() {
      return (
        this.email.length >= 4 &&
        this.password.length >= 6
      )
    },

  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.deferredPrompt = event;
      // Отображение кнопки установки
      this.isShowInstallButton = true;
    });

  },
  methods: {
    submit() {
      localStorage.removeItem('token')
      this.test = true
      let self = this;
      if (this.$v.password.$error || this.$v.email.$error) {
        return;
      }

      this.$axios.post(`${process.env.API_BASE_URL}/api/auth/login/`, {
        email: this.email,
        password: this.password,
        remember: this.rememberMe,
      }).then(function (response) {
        if (!response.data.access_token) {
          return;
        }

        localStorage.setItem('token', response.data.access_token);
        self.$store.commit('userModule/SET_IS_LOGGED')
        self.$router.push(localStorage.redirectUrl ? localStorage.redirectUrl : '/account/dashboard/');
      }).catch(function (error) {
        self.isError = true
        console.log('error: ' + error);
      });
    },

    twitterGet() {

      let self = this;
      this.$axios.get(`${process.env.API_BASE_URL}/api/auth/login/twitter`, {

      })
        .then(function (response) {
          let resp = response.data
          let lnk = resp.replace('free%3D0', 'free%3D1')
          window.location.href = lnk
        })

        .catch(function (error) {
          console.log('error: ' + error);
        });



    },

    facebookGet() {
      let self = this;
      this.$axios.get(`${process.env.API_BASE_URL}/api/auth/login/facebook`, {

      })
        .then(function (response) {
          let resp = response.data
          let lnk = resp.replace('free%3D0', 'free%3D1')
          window.location.href = lnk
        })

        .catch(function (error) {
          console.log('error: ' + error);
        });
    },

    googleGet() {
      let self = this;
      this.$axios.get(`${process.env.API_BASE_URL}/api/auth/login/google`, {

      })
        .then(function (response) {
          let resp = response.data
          let lnk = resp.replace('free%3D0', 'free%3D1')
          window.location.href = lnk
        })

        .catch(function (error) {
          console.log('error: ' + error);
        });
    },

    linkedGet() {
      let self = this;
      this.$axios.get(`${process.env.API_BASE_URL}/api/auth/login/linkedin`, {

      })
        .then(function (response) {
          let resp = response.data
          let lnk = resp.replace('free%3D0', 'free%3D1')
          window.location.href = lnk
        })

        .catch(function (error) {
          console.log('error: ' + error);
        });
    },

    installApp() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            alert('The user has installed the application!');
          }
          this.deferredPrompt = null;
          // Скрытие кнопки установки после установки приложения
          this.isShowInstallButton = false;
        });
      }
    },

  }
}
